var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],class:_vm.$style.container,attrs:{"title":"Take notes"},on:{"click":_vm.takeNotes}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faPenAlt}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b36f67f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CallInfo/TakeNotesButton.vue
// module id = VgIY
// module chunks = 1